module.exports = __webpack_public_path__ + "media/images/ico-next@2x-a14806e2348f1c64757b4c481ea150df.png";